// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"Modal_pageHolder__1BXQY","modal":"Modal_modal__3HbeO"};